import { useState, useRef, useEffect } from "react";

export default function ServiceDetailStyle() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-style">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <h4>Style & Mood</h4>
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Design</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <h4 className="heading">Functional elegance and versatility, for modern interiors</h4>
                </div>

                <div className="col-lg-6 col-md-6">
                    <p>Smart storage, sleek cabinetry, and seamlessly integrated units combine with refined finishes and textures to create adaptable living and working spaces. Saysha Interiors’ modular solutions enhance functionality without compromising aesthetics, turning every environment into a stylish, organized, and highly practical experience.</p>
                </div>

            </div>
        </div>
    </section>             
    </>
  )
}
